/*global $*/

import ko from 'knockout';

export function registerComponent() {
  ko.components.register('geography-chip', {
    template: `<label data-bind="visible: visible, html: text, click: remove"></label>`,
    viewModel: {
      createViewModel: function (params, componentInfo) {
        return new GeographyChipViewModel(params, componentInfo);
      },
    },
  });
}

// eslint-disable-next-line no-unused-vars
function GeographyChipViewModel(params, componentInfo) {
  var self = this;

  self.text = ko.pureComputed(function () {
    var geography = params.data.Geography();

    if (!params.data.ShowRadius()) {
      return geography;
    }

    var radius = params.data.Radiuses().find(r => r.Value() === params.data.Radius());

    return radius ? (geography + ' (' + radius.Text() + ')') : geography;
  }, self);

  self.visible = ko.pureComputed(function () {
    return !!params.data.Geography();
  }, self);

  self.remove = function (data, event) {
    var $form = $(event.currentTarget).closest('form');
    params.data.Geography(null);
    $form.trigger('update');
  };
}
